<template>
  <div >
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <el-select v-model="formInline.region" placeholder="请选择组织结构">
            <el-option label="班级一" value="shanghai"></el-option>
            <el-option label="班级二" value="beijing"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="学生名称">
          <el-input v-model="formInline.user" placeholder="请输入学生名称"></el-input>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker v-model="formInline.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新建</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column  prop="receiver_name" label="交接老师" width="150">
        </custom-table-column>
        <custom-table-column prop="train_name" label="实训日志" width="180">
        </custom-table-column>
        <custom-table-column prop="charge" label="交接内容" min-width="360" >
        </custom-table-column>
        <!-- <custom-table-column  label="类型" width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.type=='before_class'">课前交接</span>
            <span v-else-if="scope.row.type=='after_class'">课后交接</span>
            <span v-else> 全部</span>
          </template>
        </custom-table-column> -->
        <custom-table-column prop="receive_at" label="确认时间" width="160">
        </custom-table-column>
        
        <custom-table-column fixed="right" label="操作" width="140">
          <template slot-scope="scope">
            <el-button @click="handleConfirm(scope.row.id)" v-if="!scope.row.receive_at" type="text" size="small">确认</el-button>
            <!-- <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button> -->
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total'  ref="pageChild"  @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  :title="title" :visible.sync="centerDialogVisible" width="706px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="授课老师" prop="receiver_id">
          <el-select v-model="ruleForm.receiver_id" style="width:216px;" placeholder="请选择授课老师" @change="handleTeacherChange">
            <el-option v-for="item in tearchs" :key="item.id" :label="item.username" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="实训日志" prop="train_id">
          <el-select v-model="ruleForm.train_id" style="width:216px;" placeholder="请选择实训日志" @change="handleLogChange">
            <el-option v-for="item in logs" :key="item.id" :label="item.train_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交接内容" prop="charge">
          <el-input v-model="ruleForm.charge" type="textarea" placeholder="请输入交接内容" style="width:532px;"></el-input>
        </el-form-item>

        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"  title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteEqJournal">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"  title="提示" :visible.sync="dialogVisible1" width="400px">
      <span>是否确认交接</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="confirmEqSX">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';

export default {
  name: 'JournalOfEqSX',
  mixins: [mixinList],
  data() {
    return {
      tearchs: [],
      logs: [],
      formInline: {
        user: '',
        region: '',
      },
      ruleForm: {
        receiver_id:'',
        receiver_name:'',
        train_id:'',
        train_name:'',
        charge:'',
      },
      ruleFormTep: {
        receiver_id:'',
        receiver_name:'',
        train_id:'',
        train_name:'',
        charge:'',
      },
      dialogVisible1:false,
      rules: {

        charge: [{ required: true, message: '请输入交接内容', trigger: 'blur' }],
        receiver_id: [{ required: true, message: '请选择授课老师', trigger: 'change' }],
        train_id: [{ required: true, message: '请选择实训日志', trigger: 'change' }],
        
      },
      type:'add',
      title:'新增',
      confid:''
    };
  },
  created() {
    this.getTarinLog()
  },
  mounted() {
    // this.getList();
  },
  methods: {
    handleLogChange(e) {
      this.ruleForm.train_name = this.$until.getLabelName(this.logs, 'id', 'train_name', e);
    },
    handleTeacherChange(e) {
      this.ruleForm.receiver_name = this.$until.getLabelName(this.tearchs, 'id', 'username', e);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handleExport() {
      this.$message.info('导出中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    handleConfirm(id){
      this.dialogVisible1 = true
      this.confid = id
    },
    async confirmEqSX(){
      let params = { id: this.confid };
      let res = await this.$api.update.confirmEqSX(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '确认成功！',
        });
        this.dialogVisible1 = false;
        this.handleQuery()
      }
    },
    async deleteEqJournal() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteEqJournal(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery()
      }
    },
    async createJournalOfSX() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.creat.createJournalOfSX(params);
      if (res.code == 0 ) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState()
      }
    },
    async updateJournalOfTearcher() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.update.updateJournalOfTearcher(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    async getTearchs(){
      let res = await this.$api.instance.getSkls();
      if (res.code == 0) {
        this.tearchs = res.data
      }
    },
    async getTarinLog(){
      let params = {
        page: 1,
        size: 10
      };
      let res = await this.$api.query.getJournas(params);
      if (res.code == 0 && res.data) {
        this.logs = res.data.data;
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createJournalOfSX();
          }else if(this.type == 'edit'){
            this.updateJournalOfTearcher()
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    handleQuery(){
      this.$refs.pageChild.page = 1;
      this.getList()
    },
    async getList() {
      let params = {
        page: this.$refs.pageChild.page,
        size: this.$refs.pageChild.size,
        type:'before_class'
      };
      let res = await this.$api.query.getJournasOfTeacher(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
